import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    Typography,
    TextField,
    InputAdornment,
} from "@mui/material";
import {
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from "@mui/material";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import {
    useGetAdminUserPerfiles,
} from "../../../hooks/AdministracionUsuarios/adminPerfiles/getAdminUserPerfiles";

import {
    useGetAdminUserPermisos,
} from "../../../hooks/AdministracionUserPermisos/getAdminUserPermisos";

import {
    useAddPermisosPerfil,
} from "../../../hooks/AdministracionUsuarios/adminPerfiles/addPermisosPerfil";

import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
interface AddPermisoPerfilProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
    perfil: any;
}

const AddPermisoPerfil: React.FC<AddPermisoPerfilProps> = ({
    open,
    onClose,
    onSuccess,
    perfil,
}) => {

    const {
        perfiles,
        obtenerPerfiles,
    } = useGetAdminUserPerfiles();

    const {
        permisos,
        obtenerPermisos,
    } = useGetAdminUserPermisos();

    const {
        agregarPermisoPerfil,
        loading,
    } = useAddPermisosPerfil();

    const [idPerfil, setIdPerfil] = useState(0);
    const [idPermiso, setIdPermiso] = useState(0);

    const [gruposAbiertos, setGruposAbiertos] = useState<Record<string, boolean>>({});
    const [permisosSeleccionados, setPermisosSeleccionados] = useState<number[]>([]);
    const [relacionesPermisos, setRelacionesPermisos] = useState<any[]>([]);
    const [permisosOriginales, setPermisosOriginales] = useState<number[]>([]);
    const [buscarPermiso, setBuscarPermiso] = useState("");
    const [loadingModal, setLoadingModal] = useState(false);

    const toggleGrupo = (grupo: string) => {

        setGruposAbiertos(prev => ({

            ...prev,
            [grupo]: !prev[grupo],

        }));

    };

    const togglePermiso = (id: number) => {

        setPermisosSeleccionados(prev =>

            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]

        );

    };

    const permisosFiltrados = permisos.filter((permiso: any) =>
        permiso.nombre
            .toLowerCase()
            .includes(buscarPermiso.toLowerCase())
    );

    const permisosAgrupados = permisosFiltrados.reduce((acc: any, permiso: any) => {

        if (!acc[permiso.sufijo]) {
            acc[permiso.sufijo] = [];
        }

        acc[permiso.sufijo].push(permiso);

        return acc;

    }, {});

    useEffect(() => {

        if (!open) return;

        const cargar = async () => {

            setLoadingModal(true);

            try {

                await Promise.all([
                    obtenerPerfiles(),
                    obtenerPermisos(),
                ]);

                if (perfil) {

                    setIdPerfil(perfil.id);

                    const permisosPerfil = perfil.permisos.map(
                        (permiso: any) => permiso.id
                    );

                    setPermisosOriginales(permisosPerfil);

                    setPermisosSeleccionados(permisosPerfil);

                    const grupos: Record<string, boolean> = {};

                    perfil.permisos.forEach((permiso: any) => {
                        grupos[permiso.sufijo] = true;
                    });

                    setGruposAbiertos(grupos);

                }

            } finally {

                setLoadingModal(false);

            }

        };

        cargar();

    }, [open, perfil]);

    useEffect(() => {

        if (!open) return;

        const cargar = async () => {

            await Promise.all([
                obtenerPerfiles(),
                obtenerPermisos(),
            ]);

        };

        cargar();

        setIdPerfil(0);


    }, [open]);

    const cerrarModal = () => {

        setIdPerfil(0);

        setPermisosSeleccionados([]);

        setGruposAbiertos({});

        onClose();

    };

    const guardar = async () => {

        if (idPerfil === 0) {
            return;
        }

        let todoCorrecto = true;

        const permisosAgregar =
            permisosSeleccionados.filter(
                id => !permisosOriginales.includes(id)
            );

        const permisosEliminar =
            permisosOriginales.filter(
                id => !permisosSeleccionados.includes(id)
            );

        for (const idPermiso of permisosAgregar) {

            await agregarPermisoPerfil({
                idPerfil,
                idPermiso,
                activo: true,
            });

        }

        if (todoCorrecto) {

            await onSuccess?.();

            cerrarModal();

        }

    };


    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "98%",
                    maxWidth: 1350,
                    height: "90vh",
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        Asignar Permiso a Perfil
                    </Typography>

                    <IconButton
                        onClick={cerrarModal}
                    >
                        <CloseIcon />
                    </IconButton>

                </Box>

                <Divider sx={{ mb: 3 }} />

                {loadingModal ? (

                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 550,
                            gap: 2,
                        }}
                    >

                        <CircularProgress size={60} />

                        <Typography
                            variant="body1"
                            color="text.secondary"
                            fontWeight={500}
                        >
                            Cargando información...
                        </Typography>

                    </Box>

                ) : (

                    <>

                        <Box
                            display="flex"
                            flexDirection="column"
                            gap={3}
                        >

                            <FormControl fullWidth>
                                <Box>

                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        sx={{ mb: 2 }}
                                    >
                                        Perfil:
                                        <Typography
                                            component="span"
                                            color="primary"
                                            fontWeight="bold"
                                            sx={{ ml: 1 }}
                                        >
                                            {perfil?.nombre}
                                        </Typography>
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Buscar permiso..."
                                        value={buscarPermiso}
                                        onChange={(e) => setBuscarPermiso(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{ mb: 2 }}
                                    />

                                </Box>

                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        maxHeight: 550,
                                    }}
                                >

                                    <Table>

                                        <TableBody>

                                            {Object.entries(permisosAgrupados).map(
                                                ([grupo, lista]: any) => (

                                                    <React.Fragment key={grupo}>

                                                        <TableRow
                                                            hover
                                                            onClick={() => toggleGrupo(grupo)}
                                                            sx={{
                                                                cursor: "pointer",
                                                                bgcolor: "#F5F5F5",
                                                            }}
                                                        >

                                                            <TableCell
                                                                colSpan={2}
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                }}
                                                            >

                                                                {gruposAbiertos[grupo]
                                                                    ? <KeyboardArrowDownIcon sx={{ mr: 1 }} />
                                                                    : <KeyboardArrowRightIcon sx={{ mr: 1 }} />
                                                                }

                                                                {grupo} ({lista.length})

                                                            </TableCell>

                                                        </TableRow>

                                                        {gruposAbiertos[grupo] && (

                                                            <Box
                                                                sx={{
                                                                    p: 2,
                                                                    display: "flex",
                                                                    flexWrap: "wrap",
                                                                    columnGap: 8,
                                                                    rowGap: 1,
                                                                }}
                                                            >

                                                                {lista.map((permiso: any) => (

                                                                    <Box
                                                                        key={permiso.id}
                                                                        sx={{
                                                                            width: 260,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >

                                                                        <Checkbox
                                                                            size="small"
                                                                            checked={permisosSeleccionados.includes(permiso.id)}
                                                                            disabled={permisosOriginales.includes(permiso.id)}
                                                                            onChange={() => togglePermiso(permiso.id)}
                                                                            sx={{
                                                                                p: 0.3,
                                                                                mr: 0.5,
                                                                                color: "#1976d2",
                                                                                "&.Mui-checked": {
                                                                                    color: "#1976d2",
                                                                                },
                                                                                "&.Mui-disabled": {
                                                                                    color: "#1976d2",
                                                                                },
                                                                                "&.Mui-checked.Mui-disabled": {
                                                                                    color: "#1976d2",
                                                                                },
                                                                            }}
                                                                        />

                                                                        <Typography
                                                                            fontSize={13}
                                                                        >
                                                                            {permiso.nombre}
                                                                        </Typography>

                                                                    </Box>

                                                                ))}

                                                            </Box>

                                                        )}

                                                    </React.Fragment>

                                                )

                                            )}

                                        </TableBody>

                                    </Table>

                                </TableContainer>

                            </FormControl>

                        </Box>

                        <Divider sx={{ my: 3 }} />

                        <Box
                            sx={{
                                mt: "auto",
                                pt: 3,
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 2,
                            }}
                        >

                            <Button
                                variant="contained"
                                onClick={cerrarModal}
                                sx={{
                                    bgcolor: "#F70083",
                                    color: "#fff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderRadius: 2,
                                    px: 3,
                                    "&:hover": {
                                        bgcolor: "#D60072",
                                    },
                                }}
                            >
                                Cancelar
                            </Button>

                            <Button
                                variant="contained"
                                onClick={guardar}
                                disabled={
                                    loading ||
                                    idPerfil === 0 ||
                                    permisosSeleccionados.length === 0
                                }
                                sx={{
                                    bgcolor: "#2e7d32",
                                    color: "#fff",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderRadius: 2,
                                    px: 3,
                                    "&:hover": {
                                        bgcolor: "#1b5e20",
                                    },
                                }}
                            >
                                {loading ? (
                                    <>
                                        <CircularProgress
                                            size={18}
                                            color="inherit"
                                            sx={{ mr: 1 }}
                                        />
                                        Guardando...
                                    </>
                                ) : (
                                    "Asignar Permisos"
                                )}
                            </Button>

                        </Box>

                    </>

                )}
            </Box>

        </Modal>

    );

};

export default AddPermisoPerfil;